import { type FC } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

import { sanitizeAttributeName } from '../helpers';

interface Props {
	attributeName: string;
	oldValue: string;
	newValue: string;
	isNew: boolean;
}

const AttributesDiff: FC<Props> = (props) => {
	const { attributeName, oldValue, newValue, isNew } = props;

	return (
		<div className="attributeChangeBlock">
			<div className="label">{sanitizeAttributeName(attributeName)}</div>
			<ReactDiffViewer
				oldValue={oldValue}
				newValue={newValue}
				styles={{ line: { wordBreak: 'break-word' } }}
				splitView={!isNew}
				hideLineNumbers={isNew}
				extraLinesSurroundingDiff={1}
				compareMethod={DiffMethod.WORDS}
			/>
		</div>
	);
};

export default AttributesDiff;
